export * from "./physician-portal-access.guard";
export * from "./physician-portal-auth.guard";
export * from "./route-guards";



// WEBPACK FOOTER //
// ./src/app/shared/guard/physician-portal/index.ts